import { useNavigate } from "react-router-dom";
import { mdiPlus } from "@mdi/js";
import Icon from "@mdi/react";

import { routes } from "constants/routes";
import styles from "./style.module.scss";

export default function HomeAddingCard() {
  const navigate = useNavigate();

  const goToCardSettings = () => {
    navigate(routes.HOME_CARD_SETTINGS);
  };

  return (
    <button className={styles.addingCardContainer} onClick={goToCardSettings}>
      <Icon path={mdiPlus} className="flex-none size-7" />
      <span className="whitespace-nowrap">Add a Card</span>
    </button>
  );
}
